import {
  SwiperError,
  SwiperErrorResponse,
} from '../../components/payments/lspay-payment-modal/helpers/lspay.types'

/**
 * Processing Service error response format (returned as raw passthrough from Swiper proxy).
 * Different from Swiper's own validation error format (SwiperErrorResponse).
 */
export interface ProcessingServiceErrorResponse {
  error: {
    message: string
    code: string
    hint?: string
    details?: Record<string, unknown>
  }
}

function isProcessingServiceError(
  body: unknown
): body is ProcessingServiceErrorResponse {
  return (
    typeof body === 'object' &&
    body !== null &&
    'error' in body &&
    typeof (body as any).error === 'object' &&
    typeof (body as any).error?.message === 'string'
  )
}

function isSwiperError(body: unknown): body is SwiperErrorResponse {
  return (
    typeof body === 'object' &&
    body !== null &&
    'error' in body &&
    typeof (body as any).error === 'string'
  )
}

/**
 * Parses error responses from the Swiper proxy, which can return two formats:
 * - Swiper validation errors: { error: string, code: number, fields: any }
 * - Processing Service errors (raw passthrough): { error: { message, code, hint, details } }
 */
export function parseProxyErrorResponse(body: unknown): SwiperError {
  if (isSwiperError(body)) {
    return new SwiperError(body.error, body.code, body.fields)
  }

  if (isProcessingServiceError(body)) {
    return new SwiperError(
      body.error.message,
      (body.error.code as unknown) as number,
      body.error.details ?? null
    )
  }

  return new SwiperError('Unknown error', 0, null)
}
